import React from "react";
import { Toast as UiToast } from "@zorni/components-lib";
import { useOperation } from "../../hooks/useOperation";

export default function Toast() {
  const { toast, closeToast } = useOperation();

  return (
    <UiToast
      isVisible={toast.isVisible}
      message={toast.message}
      type={toast.type}
      onClose={closeToast}
      iconName={toast.iconName}
    />
  );
}
